import { render, staticRenderFns } from "./cartBuy.vue?vue&type=template&id=5f5b8a04&scoped=true&"
import script from "./cartBuy.vue?vue&type=script&lang=js&"
export * from "./cartBuy.vue?vue&type=script&lang=js&"
import style0 from "./cartBuy.vue?vue&type=style&index=0&id=5f5b8a04&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b8a04",
  null
  
)

export default component.exports